import React from 'react';
import PanelContainer from '@/components/wrappers/PanelContainer';

const DataManagementPanelContainer = ({
  canRead,
  children,
  exists,
  readErrors,
  readStatus,
}) => (
  <PanelContainer
    canAccess={canRead}
    entity="dataset.data.management"
    exists={exists}
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    {children}
  </PanelContainer>
);

export default DataManagementPanelContainer;
